enum CUSTOM_SECTION_TYPE {
  HERO_CAROUSEL = 'HERO_CAROUSEL',
  HERO_BANNER = 'HERO_BANNER',
  HERO_BANNER_V2 = 'HERO_BANNER_V2',
  PRICING_COMPARISON = 'PRICING_COMPARISON',
  CATEGORIES_SHOWCASE = 'CATEGORIES_SHOWCASE',
  CATEGORY_SHOWCASE = 'CATEGORY_SHOWCASE',
  PRODUCT_SHOWCASE = 'PRODUCT_SHOWCASE',
  TABS = 'TABS',
  PRODUCT_LIST = 'PRODUCT_LIST',
  INFORMATION_BOXES = 'INFORMATION_BOXES',
  PARTNER_FLAT_PRODUCT_LIST = 'PARTNER_FLAT_PRODUCT_LIST',
  FLAT_PRODUCT_LIST = 'FLAT_PRODUCT_LIST',
  HONEST_REVIEW = 'HONEST_REVIEW',
  INFLUENCER = 'INFLUENCER',
  PRODUCT_LIST_TWO = 'PRODUCT_LIST_TWO',
  PRODUCT_LIST_THREE = 'PRODUCT_LIST_THREE',
  ACCORDION = 'ACCORDION',
  ACCORDION_ITEM = 'ACCORDION_ITEM',
  RICH_TEXT = 'RICH_TEXT',
  RICH_TEXT_WITH_BORDER = 'RICH_TEXT_WITH_BORDER',
  IMAGE_WITH_CONTENT_WITH_BORDER_SECTION = 'IMAGE_WITH_CONTENT_WITH_BORDER_SECTION',
  FUll_IMAGE_WITH_CONTENT = 'FUll_IMAGE_WITH_CONTENT',
  SUPPLY_CHAIN = 'SUPPLY_CHAIN',
  PRODUCT_PROMOTION_GRID = 'PRODUCT_PROMOTION_GRID',
  FEATURE_SECTION_5 = 'FEATURE_SECTION_5',
  FEATURE_SECTION_6 = 'FEATURE_SECTION_6',
  TEXT_WITH_IMAGE = 'TEXT_WITH_IMAGE',
  TEXT_WITH_IMAGE_CAROUSEL = 'TEXT_WITH_IMAGE_CAROUSEL',
  FEATURE_SECTION_2 = 'FEATURE_SECTION_2',
  FEATURE_SECTION_4 = 'FEATURE_SECTION_4',
  SEARCH_SECTION = 'SEARCH_SECTION',
  FILL_RANGE_BAR = 'FILL_RANGE_BAR',
  PRODUCT_CARD_TWO_LIST = 'PRODUCT_CARD_TWO_LIST',
  PRODUCT_DETAILS_ICONS = 'PRODUCT_DETAILS_ICONS',
  FLEXIBLE_IMAGE_WITH_TEXT = 'FLEXIBLE_IMAGE_WITH_TEXT',
  PRODUCT_LIST_WITH_TEXT = 'PRODUCT_LIST_WITH_TEXT',
  CART_SECTION = 'CART_SECTION',
  IDME_CALLBACK_SECTION = 'IDME_CALLBACK_SECTION',
  IDME_VERIFICATION_SECTION = 'IDME_VERIFICATION_SECTION',
  FORM_MODAL = 'FORM_MODAL',
  FEATURE_SECTION_7 = 'FEATURE_SECTION_7',
  PARTNER_PDP_LANDING_FORM = 'PARTNER_PDP_LANDING_FORM',
  RECOMMENDED_PRODUCT_LIST = 'RECOMMENDED_PRODUCT_LIST',
  NEW_ARRIVAL_PRODUCT_LIST = 'NEW_ARRIVAL_PRODUCT_LIST',
  MODAL = 'MODAL',
  MEASURING_GUIDE = 'MEASURING_GUIDE',
  AIRLINE_COMPATIBILITY_LISTING = 'AIRLINE_COMPATIBILITY_LISTING',
  FEATURE_SECTION_7_NEW = 'FEATURE_SECTION_7_NEW',
  FEATURE_SECTION_7_LANDING = 'FEATURE_SECTION_7_LANDING',
  FULL_BLEED_MEDIA = 'FULL_BLEED_MEDIA',
  ROW_OF_IMAGE_TEXT_BLOCKS = 'ROW_OF_IMAGE_TEXT_BLOCKS',
  TEXT_BLOCK_WITH_ICON_ROW = 'TEXT_BLOCK_WITH_ICON_ROW',
  STACKED_NEW_LONG_FORM = 'STACKED_NEW_LONG_FORM',
  COLLECTION_PROMO_BANNER = 'COLLECTION_PROMO_BANNER',
  MULTIPLE_HERO_BANNERS = 'MULTIPLE_HERO_BANNERS',
  HALF_BANNER_HALF_PRODUCT_TILES = 'HALF_BANNER_HALF_PRODUCT_TILES',
  CATEGORY_SHOWCASE_V2 = 'CATEGORY_SHOWCASE_V2',
  HONEST_REVIEWS_V2 = 'HONEST_REVIEWS_V2',
  PERSONALISED_PRODUCTS = 'PERSONALISED_PRODUCTS',
  BACK_TO_SCHOOL = 'BACK_TO_SCHOOL',
  INFLUENCER_V2 = 'INFLUENCER_V2',
  EVENT_HIGHLIGHTS = 'EVENT_HIGHLIGHTS',
  LOGO_CAROUSEL = 'LOGO_CAROUSEL',
  LIVE_EVENT = 'LIVE_EVENT',
  LIVE_TIMER_WITH_CONTENT = 'LIVE_TIMER_WITH_CONTENT',
  LIVE_TITLE_CONTENT = 'LIVE_TITLE_CONTENT',
  LIVE_CTAS = 'LIVE_CTAS',
  LIVE_FOOTER = 'LIVE_FOOTER',
  RECRUITING_PROCESS = 'RECRUITING_PROCESS',
  TEAMS_GRID = 'TEAMS_GRID',
  CULTURE_GRID = 'CULTURE_GRID',
}

export default CUSTOM_SECTION_TYPE
